module.exports = __webpack_public_path__ + "img/basket.792999da.svg";